(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
      this.wrapper = this;
      if (this.wrapper.classList.contains('header-wrapper--transparent')) {
        window.addEventListener('scroll', this.handleTransparency.bind(this), { passive: true });
        this.handleTransparency();
      }
    }
    handleTransparency() {
      if (window.scrollY > 40) { this.wrapper.classList.add('header-wrapper--scrolled'); }
      else { this.wrapper.classList.remove('header-wrapper--scrolled'); }
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) { requestAnimationFrame(this.reveal.bind(this)); }
        else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-brand-editorial"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var grid = root.querySelector('.tb-brand-editorial--duo .tb-brand-editorial__grid');
    var bar = root.querySelector('.tb-brand-editorial__progress');
    if (!grid || !bar || grid.dataset.tbReady) return;
    grid.dataset.tbReady = '1';
    function update() {
      var max = grid.scrollWidth - grid.clientWidth;
      var p = max > 0 ? Math.min(1, Math.max(0, grid.scrollLeft / max)) : 0;
      bar.style.setProperty('--tb-p', p.toFixed(3));
      bar.style.visibility = max > 4 ? 'visible' : 'hidden';
    }
    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function boot() { document.querySelectorAll('.tb-brand-editorial').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-categories"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var track = root.querySelector('[data-tb-drag-scroll]');
    if (!track || track.dataset.tbReady) return;
    track.dataset.tbReady = '1';
    var viewport = root.querySelector('.tb-categories__viewport');
    var arrows = root.querySelectorAll('[data-tb-scroll]');

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (viewport) viewport.classList.toggle('is-overflowing', max > 4);
      arrows.forEach(function (b) {
        var dir = parseInt(b.getAttribute('data-tb-scroll'), 10);
        b.disabled = dir < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max - 2;
      });
    }
    function step() {
      var card = track.querySelector('.tb-categories__card');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    }
    arrows.forEach(function (b) {
      b.addEventListener('click', function () {
        track.scrollBy({ left: step() * parseInt(b.getAttribute('data-tb-scroll'), 10), behavior: 'smooth' });
      });
    });

    /* Arrastar com mouse (equivalente ao grabCursor/freeMode do Swiper da Benigno).
       Touch continua nativo. */
    var down = false, moved = false, startX = 0, startLeft = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); }
      if (moved) track.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      if (moved) setTimeout(function () { track.classList.remove('is-dragging'); }, 0);
    });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function boot() { document.querySelectorAll('.tb-categories').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-product-main-pronta-entrega"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.tb-pdp').forEach(function(pdp){
    var sid = pdp.getAttribute('data-section');
    var nparc  = parseInt(pdp.getAttribute('data-nparc'),10)  || 10;
    var pixpct = parseInt(pdp.getAttribute('data-pixpct'),10) || 0;
    var fmt    = new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'});
    var q      = function(s){ return pdp.querySelector(s); };
    var priceEl=q('#tb-price-'+sid),compareEl=q('#tb-compare-'+sid),discEl=q('#tb-disc-'+sid),econEl=q('#tb-econ-'+sid),parcEl=q('#tb-parc-'+sid),pixEl=q('#tb-pix-'+sid),vidEl=q('.tb-vid'),ctaBtn=q('.tb-cta'),addBtn=q('.tb-add'),mainImg=q('#tb-main-'+sid),qtyInput=q('.tb-qty-input');
    pdp.querySelectorAll('.tb-thumb').forEach(function(btn){ btn.addEventListener('click',function(){ if(mainImg)mainImg.src=btn.getAttribute('data-full'); pdp.querySelectorAll('.tb-thumb').forEach(function(b){b.classList.remove('is-active');}); btn.classList.add('is-active'); }); });
    pdp.querySelectorAll('.tb-qty-btn').forEach(function(b){ b.addEventListener('click',function(){ var dir=parseInt(b.getAttribute('data-dir'),10); qtyInput.value=Math.max(1,(parseInt(qtyInput.value,10)||1)+dir); }); });
    var tbVarData=window['tbV_'+sid]||[];
    function getSelOpts(){ var o=[]; pdp.querySelectorAll('[data-opt] .tb-select').forEach(function(sel){o.push(sel.value);}); return o; }
    function allOptsSelected(){ var ok=true; pdp.querySelectorAll('[data-opt] .tb-select').forEach(function(sel){if(sel.value==='')ok=false;}); return ok; }
    function updateButtons(enable){ if(ctaBtn)ctaBtn.disabled=!enable; if(addBtn)addBtn.disabled=!enable; }
    function findVar(opts){ return tbVarData.find(function(v){return v.options.every(function(op,i){return op===opts[i];});})||null; }
    function recalc(v){
      if(!v)return;
      var cents=v.price,compare=v.compare_at_price||0;
      if(vidEl)vidEl.value=v.id;
      if(priceEl)priceEl.textContent=fmt.format(cents/100);
      var hasC=compare>cents;
      if(compareEl)compareEl.style.display=hasC?'':'none';
      if(discEl)discEl.style.display=hasC?'':'none';
      if(econEl)econEl.style.display=hasC?'':'none';
      if(hasC){ if(compareEl)compareEl.textContent=fmt.format(compare/100); if(discEl)discEl.textContent='-'+Math.round((compare-cents)/compare*100)+'%'; if(econEl)econEl.textContent='economia de '+fmt.format((compare-cents)/100); }
      if(parcEl){ var parc=Math.floor(cents/10); parcEl.textContent='Até 10x sem juros de '+fmt.format(parc/100); }
      if(pixEl&&pixpct>0)pixEl.textContent=fmt.format(cents*(100-pixpct)/100/100);
      if(v.featured_image&&v.featured_image.src&&mainImg)mainImg.src=v.featured_image.src;
    }
    function recalcFromOpts(){ var v=findVar(getSelOpts()); if(v)recalc(v); pdp.querySelectorAll('[data-opt] .tb-select').forEach(function(sel){if(sel.value==='')sel.classList.add('tb-placeholder-color');else sel.classList.remove('tb-placeholder-color');var w=sel.closest('[data-opt]'),c=w?pdp.querySelector('[data-opt-chosen="'+w.getAttribute('data-opt')+'"]'):null;if(c)c.textContent=sel.value||'';}); updateButtons(allOptsSelected()&&(!v||v.available)); }
    pdp.querySelectorAll('[data-opt] .tb-select').forEach(function(sel){sel.addEventListener('change',recalcFromOpts);});
    recalcFromOpts();
    function addToCart(redirect){ var id=vidEl?vidEl.value:null,qty=parseInt(qtyInput?qtyInput.value:1,10)||1; if(!id)return; fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:qty})}).then(function(r){return r.json();}).then(function(){window.location.href=redirect;}).catch(function(){window.location.href=redirect;}); }
    if(ctaBtn){ctaBtn.addEventListener('click',function(e){e.preventDefault();addToCart('/checkout');});}
    if(addBtn){addBtn.addEventListener('click',function(e){e.preventDefault();
      console.log('[TB CART] button clicked');
      var id=vidEl?vidEl.value:null,qty=parseInt(qtyInput?qtyInput.value:1,10)||1;
      if(!id){ console.log('[TB CART] no variant selected'); return; }
      console.log('[TB CART] variant id', id);
      addBtn.disabled=true;

      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:qty,sections:['cart-drawer','cart-icon-bubble'],sections_url:window.location.pathname})})
        .then(function(r){
          if(!r.ok){ return r.json().then(function(d){ throw d; }); }
          return r.json();
        })
        .then(function(response){
          console.log('[TB CART] ajax success');
          addBtn.disabled=false;

            var cartDrawer=document.querySelector('cart-drawer');
            console.log('[TB CART] drawer found', !!cartDrawer);
            if(cartDrawer&&typeof cartDrawer.renderContents==='function'){
              console.log('[TB CART] renderContents called');
              cartDrawer.renderContents(response);
            } else {
              console.log('[TB CART] fallback used');
              fetch('/cart?section_id=cart-drawer').then(function(r){return r.text();}).then(function(html){
                var tmp=document.createElement('div');
                tmp.innerHTML=html;
                var inner=tmp.querySelector('.drawer__inner');
                if(cartDrawer&&inner){ cartDrawer.innerHTML=inner.innerHTML; if(typeof cartDrawer.open==='function') cartDrawer.open(); }
                else { window.location.href='/cart'; }
              }).catch(function(){ window.location.href='/cart'; });
            }

        })
        .catch(function(){ addBtn.disabled=false; window.location.href='/cart'; });
    });}
    pdp.querySelectorAll('.tb-arr').forEach(function(btn){
      btn.addEventListener('click',function(){
        var carouselId=btn.getAttribute('data-carousel'),carousel=document.getElementById(carouselId);
        if(!carousel)return;
        var dir=parseInt(btn.getAttribute('data-dir'),10),item=carousel.querySelector('.tb-carousel-item'),scrollAmt=item?(item.offsetWidth+18)*2:460;
        carousel.scrollBy({left:dir*scrollAmt,behavior:'smooth'});
      });
    });
    (function(){
      var videoBtn = pdp.querySelector('[data-video-btn]');
      if(!videoBtn) return;
      var modal = pdp.querySelector('.tb-video-modal');
      var modalVid = modal ? modal.querySelector('.tb-video-modal-player') : null;

      function ensureSrc(video){
        if(video && !video.getAttribute('src')){
          var src = video.getAttribute('data-video-src');
          if(src) video.setAttribute('src', src);
        }
      }

      function stopModalVideo(){
        if(modalVid){ modalVid.pause(); modalVid.currentTime = 0; }
      }

      function openModal(){
        if(!modal) return;
        ensureSrc(modalVid);
        modal.classList.add('is-open');
        if(modalVid) modalVid.play();
      }

      function closeModal(){
        if(!modal) return;
        modal.classList.remove('is-open');
        stopModalVideo();
      }

      videoBtn.addEventListener('click', function(){
        openModal();
      });

      if(modal){
        modal.querySelectorAll('[data-video-modal-close]').forEach(function(el){
          el.addEventListener('click', closeModal);
        });
        document.addEventListener('keydown', function(e){
          if(e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
        });
      }
    })();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-product-main"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.tb-pdp').forEach(function(pdp){
    var sid = pdp.getAttribute('data-section');
    var nparc  = parseInt(pdp.getAttribute('data-nparc'),10)  || 10;
    var pixpct = parseInt(pdp.getAttribute('data-pixpct'),10) || 0;
    var fmt    = new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'});
    var q      = function(s){ return pdp.querySelector(s); };
    var priceEl=q('#tb-price-'+sid),compareEl=q('#tb-compare-'+sid),discEl=q('#tb-disc-'+sid),econEl=q('#tb-econ-'+sid),parcEl=q('#tb-parc-'+sid),pixEl=q('#tb-pix-'+sid),vidEl=q('.tb-vid'),ctaBtn=q('.tb-cta'),addBtn=q('.tb-add'),mainImg=q('#tb-main-'+sid),qtyInput=q('.tb-qty-input');
    pdp.querySelectorAll('.tb-thumb').forEach(function(btn){ btn.addEventListener('click',function(){ if(mainImg)mainImg.src=btn.getAttribute('data-full'); pdp.querySelectorAll('.tb-thumb').forEach(function(b){b.classList.remove('is-active');}); btn.classList.add('is-active'); }); });
    pdp.querySelectorAll('.tb-qty-btn').forEach(function(b){ b.addEventListener('click',function(){ var dir=parseInt(b.getAttribute('data-dir'),10); qtyInput.value=Math.max(1,(parseInt(qtyInput.value,10)||1)+dir); }); });
    var tbVarData=window['tbV_'+sid]||[];
    function getSelOpts(){ var o=[]; pdp.querySelectorAll('[data-opt] .tb-select').forEach(function(sel){o.push(sel.value);}); return o; }
    function allOptsSelected(){ var ok=true; pdp.querySelectorAll('[data-opt] .tb-select').forEach(function(sel){if(sel.value==='')ok=false;}); return ok; }
    function updateButtons(enable){ if(ctaBtn)ctaBtn.disabled=!enable; if(addBtn)addBtn.disabled=!enable; }
    function findVar(opts){ return tbVarData.find(function(v){return v.options.every(function(op,i){return op===opts[i];});})||null; }
    function recalc(v){
      if(!v)return;
      var cents=v.price,compare=v.compare_at_price||0;
      if(vidEl)vidEl.value=v.id;
      if(priceEl)priceEl.textContent=fmt.format(cents/100);
      var hasC=compare>cents;
      if(compareEl)compareEl.style.display=hasC?'':'none';
      if(discEl)discEl.style.display=hasC?'':'none';
      if(econEl)econEl.style.display=hasC?'':'none';
      if(hasC){ if(compareEl)compareEl.textContent=fmt.format(compare/100); if(discEl)discEl.textContent='-'+Math.round((compare-cents)/compare*100)+'%'; if(econEl)econEl.textContent='economia de '+fmt.format((compare-cents)/100); }
      if(parcEl){ var parc=Math.floor(cents/10); parcEl.textContent='Até 10x sem juros de '+fmt.format(parc/100); }
      if(pixEl&&pixpct>0)pixEl.textContent=fmt.format(cents*(100-pixpct)/100/100);
      if(v.featured_image&&v.featured_image.src&&mainImg)mainImg.src=v.featured_image.src;
    }
    function recalcFromOpts(){ var v=findVar(getSelOpts()); if(v)recalc(v); pdp.querySelectorAll('[data-opt] .tb-select').forEach(function(sel){if(sel.value==='')sel.classList.add('tb-placeholder-color');else sel.classList.remove('tb-placeholder-color');var w=sel.closest('[data-opt]'),c=w?pdp.querySelector('[data-opt-chosen="'+w.getAttribute('data-opt')+'"]'):null;if(c)c.textContent=sel.value||'';}); updateButtons(allOptsSelected()&&(!v||v.available)); }
    pdp.querySelectorAll('[data-opt] .tb-select').forEach(function(sel){sel.addEventListener('change',recalcFromOpts);});
    recalcFromOpts();
    function addToCart(redirect){ var id=vidEl?vidEl.value:null,qty=parseInt(qtyInput?qtyInput.value:1,10)||1; if(!id)return; fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:qty})}).then(function(r){return r.json();}).then(function(){window.location.href=redirect;}).catch(function(){window.location.href=redirect;}); }
    if(ctaBtn){ctaBtn.addEventListener('click',function(e){e.preventDefault();addToCart('/checkout');});}
    if(addBtn){addBtn.addEventListener('click',function(e){e.preventDefault();
      console.log('[TB CART] button clicked');
      var id=vidEl?vidEl.value:null,qty=parseInt(qtyInput?qtyInput.value:1,10)||1;
      if(!id){ console.log('[TB CART] no variant selected'); return; }
      console.log('[TB CART] variant id', id);
      addBtn.disabled=true;

      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:qty,sections:['cart-drawer','cart-icon-bubble'],sections_url:window.location.pathname})})
        .then(function(r){
          if(!r.ok){ return r.json().then(function(d){ throw d; }); }
          return r.json();
        })
        .then(function(response){
          console.log('[TB CART] ajax success');
          addBtn.disabled=false;

            var cartDrawer=document.querySelector('cart-drawer');
            console.log('[TB CART] drawer found', !!cartDrawer);
            if(cartDrawer&&typeof cartDrawer.renderContents==='function'){
              console.log('[TB CART] renderContents called');
              cartDrawer.renderContents(response);
            } else {
              console.log('[TB CART] fallback used');
              fetch('/cart?section_id=cart-drawer').then(function(r){return r.text();}).then(function(html){
                var tmp=document.createElement('div');
                tmp.innerHTML=html;
                var inner=tmp.querySelector('.drawer__inner');
                if(cartDrawer&&inner){ cartDrawer.innerHTML=inner.innerHTML; if(typeof cartDrawer.open==='function') cartDrawer.open(); }
                else { window.location.href='/cart'; }
              }).catch(function(){ window.location.href='/cart'; });
            }

        })
        .catch(function(){ addBtn.disabled=false; window.location.href='/cart'; });
    });}
    pdp.querySelectorAll('.tb-arr').forEach(function(btn){
      btn.addEventListener('click',function(){
        var carouselId=btn.getAttribute('data-carousel'),carousel=document.getElementById(carouselId);
        if(!carousel)return;
        var dir=parseInt(btn.getAttribute('data-dir'),10),item=carousel.querySelector('.tb-carousel-item'),scrollAmt=item?(item.offsetWidth+18)*2:460;
        carousel.scrollBy({left:dir*scrollAmt,behavior:'smooth'});
      });
    });
    (function(){
      var card = pdp.querySelector('#tb-eta-card-'+sid);
      if(!card) return;
      var datesEl = card.querySelector('[data-eta-dates]');
      var regionEl = card.querySelector('[data-eta-region]');
      var MIN_DAYS = 12, MAX_DAYS = 15;
      var meses = ['janeiro','fevereiro','março','abril','maio','junho','julho','agosto','setembro','outubro','novembro','dezembro'];
      function addBusinessDays(start, n){
        var d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
        var added = 0;
        while(added < n){
          d.setDate(d.getDate() + 1);
          var w = d.getDay();
          if(w !== 0 && w !== 6) added++;
        }
        return d;
      }
      function fmtDate(d){ return d.getDate() + ' de ' + meses[d.getMonth()]; }
      function render(regionText){
        var hoje = new Date();
        var d1 = addBusinessDays(hoje, MIN_DAYS);
        var d2 = addBusinessDays(hoje, MAX_DAYS);
        if(datesEl) datesEl.textContent = 'Entre ' + fmtDate(d1) + ' e ' + fmtDate(d2);
        if(regionEl) regionEl.textContent = regionText;
      }
      render('Entrega disponível para todo o Brasil');
      var cacheKey = 'tb_geo_v1';
      function applyGeo(g){
        if(g && g.city && g.region){
          render('para ' + g.city + ', ' + g.region);
        }
      }
      try{
        var cached = sessionStorage.getItem(cacheKey);
        if(cached){ applyGeo(JSON.parse(cached)); return; }
      }catch(e){}
      var ctrl = ('AbortController' in window) ? new AbortController() : null;
      var t = setTimeout(function(){ if(ctrl) ctrl.abort(); }, 2500);
      fetch('https://ipapi.co/json/', ctrl ? { signal: ctrl.signal } : undefined)
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(j){
          clearTimeout(t);
          if(!j || j.country_code !== 'BR') return;
          var g = { city: j.city, region: j.region_code };
          try{ sessionStorage.setItem(cacheKey, JSON.stringify(g)); }catch(e){}
          applyGeo(g);
        })
        .catch(function(){ clearTimeout(t); });
    })();
    (function(){
      var videoBtn = pdp.querySelector('[data-video-btn]');
      if(!videoBtn) return;
      var modal = pdp.querySelector('.tb-video-modal');
      var modalVid = modal ? modal.querySelector('.tb-video-modal-player') : null;

      function ensureSrc(video){
        if(video && !video.getAttribute('src')){
          var src = video.getAttribute('data-video-src');
          if(src) video.setAttribute('src', src);
        }
      }

      function stopModalVideo(){
        if(modalVid){ modalVid.pause(); modalVid.currentTime = 0; }
      }

      function openModal(){
        if(!modal) return;
        ensureSrc(modalVid);
        modal.classList.add('is-open');
        if(modalVid) modalVid.play();
      }

      function closeModal(){
        if(!modal) return;
        modal.classList.remove('is-open');
        stopModalVideo();
      }

      videoBtn.addEventListener('click', function(){
        openModal();
      });

      if(modal){
        modal.querySelectorAll('[data-video-modal-close]').forEach(function(el){
          el.addEventListener('click', closeModal);
        });
        document.addEventListener('keydown', function(e){
          if(e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
        });
      }
    })();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
